import React from "react";
import NumberFormat from "react-number-format";
import { baseSymbol } from "../../core/currency";

export function StockCounter({ count, totalBuyingPrice, totalListingPrice }) {
  const prefix = baseSymbol();
  return (
    <div className="d-flex justify-content-start list-toolbar">
      <div className="align-self-center ms-4">
        {count !== null && (
          <>
            <strong>{`${count} listing${count !== 1 ? "s" : ""} `}</strong>
            <span className="stock-totals">
              <NumberFormat
                value={totalBuyingPrice}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"| BP: " + prefix}
                className="total-listing-prices"
              />
              <NumberFormat
                value={totalListingPrice}
                displayType={"text"}
                thousandSeparator={true}
                prefix={" - SP: " + prefix}
                className="total-listing-prices"
              />
            </span>
          </>
        )}
      </div>
    </div>
  );
}
